import React, { useCallback } from "react";
import NavBar from './NavBar/NavBar';
import MainSideBar from './MainSideBar/MainSideBar';
import Content from './Content/Content';
import Loading from './Loading/Loading';
import { getUserSession } from "../../../util/core/Session";
import { useDispatch } from 'react-redux';

function Layout({content}) {
  const dispatch = useDispatch();
  let userSession = getUserSession();
  if(userSession.token){
    dispatch({ type: 'UPDATE_SESSION', key: 'userSession', value: userSession });
    //dispatch({ type: "UPDATE_SESSION", key: "screenConfig", value: userSession.screenConfigs?userSession.screenConfigs : {} });
    dispatch({ type: 'SHOW_LOADING', value: false });
  }
  return (
      <div className="wrapper">
          
           <NavBar/>
           <MainSideBar/>
           <Content content={content}/>
           <Loading/>
      </div>
  );
}

export default Layout;
